import {useAppSelector} from '@/hooks';

export function useGetNumberOfActiveItems(): number {
  return useAppSelector((state) => {
    return state.posterEditor.activeItemIds.length;
  });
}
